import React from 'react';

import { ArrowIcon, PdfIcon } from '@/shared/ui/icons';

import { StyledDocument, StyledBox, StyledIconWrapper } from './styled';

export const DocumentListItem: React.FC<DocumentOrder> = ({ url, name }) => {
    return (
        <StyledDocument href={`${url}`} target="_blank" rel="noreferrer">
            <StyledBox>
                <StyledIconWrapper>
                    <PdfIcon />
                </StyledIconWrapper>
                {name}
            </StyledBox>
            <StyledIconWrapper>
                <ArrowIcon />
            </StyledIconWrapper>
        </StyledDocument>
    );
};
